import { Action, Dispatch } from 'redux';
import initialState from '../initialState';
import { NotificationActions, NotificationType } from './notification/notification-actions';
import { AppDispatch } from './index';
import { getApi } from '../api/ApiProvider';
import { default as StoreModel, LoadedResource, LoadedSingleResource } from './StoreModel';
import { Company } from '../api/model';

export enum CompanyActionTypes {
    FETCH_REQUEST = '[COMPANY][LIST] Request',
    FETCH_RESPONSE = '[COMPANY][LIST] Response',
    FETCH_ERROR = '[COMPANY][ERROR] error',
    ADD_USER_REQUEST = '[COMPANY][ADD] Request',
    ADD_USER_RESPONSE = '[COMPANY][ADD] Response',
    ADD_USER_ERROR = '[COMPANY][ADD] Error',
    UPDATE_USER_REQUEST = '[COMPANY][UPDATE] Request',
    UPDATE_USER_RESPONSE = '[COMPANY][UPDATE] Response',
    UPDATE_USER_ERROR = '[COMPANY][UPDATE] Error',
    SINGLE_FETCH_REQUEST = '[COMPANY][REQUEST] Request',
    SINGLE_FETCH_RESPONSE = '[COMPANY][RESPONSE] Response',
    SINGLE_FETCH_ERROR = '[COMPANY][ERROR] error',
    ADD_IMPORT_REQUEST = '[COMPANY][IMPORT] Request',
    ADD_IMPORT_RESPONSE = '[COMPANY][IMPORT] Response',
    ADD_IMPORT_ERROR = '[COMPANY][IMPORT] Error',
    DELETE_REQUEST = '[COMPANY][DELETE] Request',
    DELETE_RESPONSE = '[COMPANY][DELETE] Response',
    DELETE_ERROR = '[COMPANY][DELETE] Error',
}

export interface CompanyState {
    data: LoadedResource<Company>,
    add: LoadedSingleResource<Company>,
    select: LoadedSingleResource<Company>
}

export default (
    state: CompanyState = initialState.company,
    action?: Action<CompanyActionTypes> & { payload: any }): CompanyState => {

    if (!action) {
        return state;
    }

    switch (action.type) {
        case CompanyActionTypes.FETCH_REQUEST:
            return {
                ...state,
                data: StoreModel.fetching()
            };

        case CompanyActionTypes.FETCH_RESPONSE:
            return {
                ...state,
                data: StoreModel.result(action.payload)
            };

        case CompanyActionTypes.FETCH_ERROR:
            return {
                ...state,
                data: StoreModel.error(action.payload)
            };

        case CompanyActionTypes.ADD_USER_REQUEST:
            return {
                ...state,
                add: StoreModel.fetchingSingle()
            };
        case CompanyActionTypes.ADD_USER_RESPONSE:
            if (StoreModel.isLoaded(state.data)) {
                return {
                    ...state,
                    data: {
                        ...state.data,
                        data: state.data.data.concat(action.payload)
                    },
                    add: StoreModel.resultSingle(action.payload)
                }
            }
            return {
                ...state,
                add: StoreModel.resultSingle(action.payload)
            };
        case CompanyActionTypes.ADD_USER_ERROR:
            return {
                ...state,
                add: StoreModel.errorSingle(action.payload)
            };

        case CompanyActionTypes.UPDATE_USER_REQUEST:
            return {
                ...state,
                select: StoreModel.fetchingSingle()
            };
        case CompanyActionTypes.UPDATE_USER_RESPONSE:
            return {
                ...state,
                select: StoreModel.resultSingle(action.payload)
            };
        case CompanyActionTypes.UPDATE_USER_ERROR:
            return {
                ...state,
                select: StoreModel.errorSingle(action.payload)
            };
        case CompanyActionTypes.SINGLE_FETCH_REQUEST:
            return {
                ...state,
                select: StoreModel.fetchingSingle()
            };
        case CompanyActionTypes.SINGLE_FETCH_RESPONSE:
            return {
                ...state,
                select: StoreModel.resultSingle(action.payload)
            };
        case CompanyActionTypes.SINGLE_FETCH_ERROR:
            return {
                ...state,
                select: StoreModel.errorSingle(action.payload)
            };
        case CompanyActionTypes.ADD_IMPORT_REQUEST:
            return {
                ...state,
                add: StoreModel.fetchingSingle()
            };
        case CompanyActionTypes.ADD_IMPORT_RESPONSE:
            if (StoreModel.isLoaded(state.data)) {
                return {
                    ...state,
                    data: {
                        ...state.data,
                        data: state.data.data.concat(action.payload)
                    },
                    add: StoreModel.resultSingle(action.payload)
                }
            }
            return {
                ...state,
                add: StoreModel.resultSingle(action.payload)
            };
        case CompanyActionTypes.ADD_IMPORT_ERROR:
            return {
                ...state,
                add: StoreModel.errorSingle(action.payload)
            };
        case CompanyActionTypes.DELETE_REQUEST:
            return {
                ...state,
                select: StoreModel.fetchingSingle()
            };
        case CompanyActionTypes.DELETE_RESPONSE:
            return {
                ...state,
                select: StoreModel.resultSingle(action.payload)
            };
        case CompanyActionTypes.DELETE_ERROR:
            return {
                ...state,
                select: StoreModel.errorSingle(action.payload)
            };
            
        default:
            return state;
    }
};

export class CompanyActions {

    add(data: { name: string, photo: string }, admin: { name: string, pass: string, email: string }) {
        return async (dispatch: AppDispatch) => {
            const notif = new NotificationActions();

            dispatch({ type: CompanyActionTypes.ADD_USER_REQUEST });

            try {
                const adminResponse = await getApi().admin().add(admin);
                const companyResponse = await getApi().company().add({
                    ...data,
                    adminId: adminResponse.id
                });
                
                dispatch({ type: CompanyActionTypes.ADD_USER_RESPONSE, payload: companyResponse });
                dispatch(notif.addSuccess('Empresa', 'Creación correcta') as any);
                
                // Retornar la respuesta de la empresa
                return companyResponse;
            } catch (err) {
                dispatch(notif.addError('Empresa', 'Ocurrio un error') as any);
                dispatch({ type: CompanyActionTypes.ADD_USER_ERROR, payload: err });
                throw err;
            }
        }
    }

    fetch() {
        return (dispatch: Dispatch) => {
            dispatch({ type: CompanyActionTypes.FETCH_REQUEST });
            getApi().company().list().then(data => {
                dispatch({ type: CompanyActionTypes.FETCH_RESPONSE, payload: data });
            }).catch(err => {
                dispatch({ type: CompanyActionTypes.FETCH_ERROR, payload: err });
            })

        }
    }

    fetchById(id: number) {
        return async (dispatch: Dispatch) => {
            dispatch({ type: CompanyActionTypes.SINGLE_FETCH_REQUEST });
            await getApi().company().byId(id).then(data => {
                dispatch({ type: CompanyActionTypes.SINGLE_FETCH_RESPONSE, payload: data });
            }).catch(err => {
                dispatch({ type: CompanyActionTypes.SINGLE_FETCH_ERROR, payload: err });
            })

        }
    }

    update(data: { name: string, photo: string, adminId: any }, id: number) {
        return (dispatch: Dispatch) => {
            // const notif = new NotificationActions();
            if (!data.adminId) {
                data.adminId = null;
            }
            dispatch({ type: CompanyActionTypes.UPDATE_USER_REQUEST });
            getApi().company().update(id, data).then(response => {
                // dispatch(notif.addSuccess('Empresa', 'Moificacion correcta'));
                dispatch({ type: CompanyActionTypes.UPDATE_USER_RESPONSE, payload: response });
            }).catch(err => {
                // dispatch(notif.addError('Empresa', 'Ocurrio un error'));
                dispatch({ type: CompanyActionTypes.UPDATE_USER_ERROR, payload: err });
            })
        }
    }

    importLocation(data: any) {
        return (dispatch: AppDispatch) => {
            const notif = new NotificationActions();
            dispatch({ type: CompanyActionTypes.ADD_IMPORT_REQUEST });
            getApi().company().importLocation(data).then(response => {
                dispatch(notif.addSuccessCus('Ubicaciones', 'Importado correctamente') as any);
                dispatch({ type: CompanyActionTypes.UPDATE_USER_RESPONSE, payload: response });
            }).catch(err => {
                dispatch(notif.addErrorCus('Ubicaciones', 'Ocurrio un error') as any);
                dispatch({ type: CompanyActionTypes.UPDATE_USER_ERROR, payload: err });
            })
        }
    }
    throwNoti(title: string, message: string,type: NotificationType) {
        {
            return (dispatch: AppDispatch) => {
                const notif = new NotificationActions();
                dispatch(notif.addInfoCus(title, message,undefined,type) as any);
            }
        }
    }

    delete(id: number) {
        return (dispatch: AppDispatch) => {
            const notif = new NotificationActions();
            if (!id) {
                return;
            }
            dispatch({ type: CompanyActionTypes.DELETE_REQUEST });
            getApi().company().delete(id).then(response => {
                dispatch(notif.addSuccess('Empresa', 'Eliminación correcta') as any);
                dispatch({ type: CompanyActionTypes.DELETE_RESPONSE, payload: response.message });
                dispatch(this.fetch());
                return response;
            }).catch(err => {
                dispatch(notif.addError('Empresa', err && err.response && err.response.message ? err.response.message : 'Error al eliminar') as any);
                dispatch({ type: CompanyActionTypes.DELETE_ERROR, payload: err && err.response && err.response.message ? err.response.message : 'Error al eliminar' });
            })
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/company.ts